var exports = {
  "k": "container__mnupps",
};

module.exports = exports;
